import axios from "../axios";
import { IAuditLogPayload } from "../../types/audit";

export const AUDIT_LOG_API = "/api/manager/audit/logs";

export const postAuditLogAPI = (token: string, data: IAuditLogPayload) => {
  const url = `${process.env.REACT_APP_PICKUP_ENDPOINT || ""}${AUDIT_LOG_API}`;
  console.log(`[audit] HTTP POST ${url}`);
  return axios.post(AUDIT_LOG_API, data, {
    headers: { token },
    baseURL: process.env.REACT_APP_PICKUP_ENDPOINT,
  });
};
